import React from 'react';
import { Paper, Grid, Typography, Box, Skeleton } from '@mui/material';
import { MdLogin, MdAddCircle, MdEdit, MdCancel } from 'react-icons/md';

const STAT_GROUPS = [
  {
    label: 'Connexions',
    icon: <MdLogin size={28} />,
    color: '#3182CE',
    bgColor: '#EBF8FF',
    keys: ['LOGIN'],
  },
  {
    label: 'Créations',
    icon: <MdAddCircle size={28} />,
    color: '#38A169',
    bgColor: '#F0FFF4',
    keys: ['CREATE', 'SUBMIT'],
  },
  {
    label: 'Modifications',
    icon: <MdEdit size={28} />,
    color: '#DD6B20',
    bgColor: '#FFFAF0',
    keys: ['UPDATE', 'APPROVE', 'COMPLETE'],
  },
  {
    label: 'Rejets & Suppressions',
    icon: <MdCancel size={28} />,
    color: '#E53E3E',
    bgColor: '#FFF5F5',
    keys: ['REJECT', 'DELETE'],
  },
];

export default function ActivityStatsCards({ stats, loading }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {STAT_GROUPS.map((group) => {
        const count = stats
          ? group.keys.reduce((sum, key) => sum + (stats[key] ?? 0), 0)
          : 0;

        return (
          <Grid item xs={12} sm={6} md={3} key={group.label}>
            <Paper
              elevation={2}
              sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                borderLeft: `4px solid ${group.color}`,
              }}
            >
              <Box
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: group.bgColor,
                  color: group.color,
                  display: 'flex',
                }}
              >
                {group.icon}
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary">
                  {group.label}
                </Typography>
                {loading ? (
                  <Skeleton width={40} height={32} />
                ) : (
                  <Typography variant="h5" fontWeight="bold" color={group.color}>
                    {count}
                  </Typography>
                )}
              </Box>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
}
